module.exports = __webpack_public_path__ + "img/app2.db541e04.jpg";